import axios, { AxiosPromise } from "axios";
import api from "api/config";

export const postRequest = (path: string, data: string, host?: string): AxiosPromise =>
  axios.post(`${api.secureProtocol}${host || api.host}${path}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
